var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegram = function SvgTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.2949 4.15008C19.2949 4.15008 21.1451 3.41422 20.9909 5.20131C20.9395 5.93717 20.477 8.51267 20.1172 11.2984L18.8838 19.5506C18.8838 19.5506 18.781 20.7595 17.8559 20.9697C16.9308 21.1799 15.5432 20.2339 15.2862 20.0236C15.0807 19.8659 11.4318 17.5007 10.147 16.3443C9.7872 16.0289 9.37605 15.3982 10.1983 14.6623L15.5946 9.40624C16.2113 8.77549 16.8281 7.30378 14.2584 9.09086L7.06339 14.0842C7.06339 14.0842 6.2411 14.6098 4.69934 14.1368L1.35877 13.0855C1.35877 13.0855 0.125338 12.2971 2.23245 11.5087C7.37177 9.03826 13.6931 6.51532 19.2949 4.15008Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export default ForwardRef;